module.exports = __webpack_public_path__ + "media/images/stamp_card-87bee8df6516f1cc75733d22f0fd001a.svg";